import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import ActionLink from "../../../../MnJsPlatform.UI.Components/lib/common/ActionLink";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import CreateClaim from "./CreateClaim";
import EditClaim from "./EditClaim";
import $ from "jquery";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";

export default (props) => {
    return <ItemInjector key={`Claim_${props.TypeClaimViewIntId}`}
                         dataItem={{
                             controller: "Claim",
                             methodName: props.settings["MethodListClaimPO"],
                             withParamset: true,
                             fieldName: props.TypeClaimViewIntId
                         }}><ConnectedInternalClaim {...props} /></ItemInjector>
}
class InternalClaim extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false,
            showCreateClaim: false,
            showEditClaim: false,
            currentClaimKey: null
        }
    }

    async componentDidMount() {
        try {
            await this.props.dispatch(this.props.dataItem.execute({}, {withParams: true}));
        } finally {
            this.setState({isDataReady: true});
        }
    }

    createNewClaim = () => {
        this.setState({showCreateClaim: true})
    };
    hideNewClaim = () => {
        this.setState({showCreateClaim: false})
    };

    claimCreated = async (row) => {
        await this.props.dispatch(this.props.dataItem.execute());
        this.editClaim(row);
    }
    deleteClaim = async (row) => {
        try {
            const key = this.props.dataItem.getRowKey(row);
            const rowIndex = this.props.dataItem.getRowIndex(key);

            await confirm(i18next.t("Delete_Request_Confirm"));
            await this.props.dispatch(this.props.dataItem.deleteRow(rowIndex));
        } catch {
        }
    }
    rollbackClaim = async (row) => {
        try {
            const key = this.props.dataItem.getRowKey(row);
            await confirm(i18next.t("Rollback_Request_Confirm"));
            await this.props.dispatch(this.props.ClaimPers_RollbackClaimPO.execute(key));
            if (!this.props.ClaimPers_RollbackClaimPO.isError)
                await this.props.dispatch(this.props.dataItem.execute());
        } catch {
        }
    }
    passClaim = async (row) => {
        try {
            await confirm(i18next.t("Send_Request_Confirm"));
            await this.props.dispatch(this.props.ClaimPersSendClaimForPO.execute(row, {withParams: true}));
            if (!this.props.ClaimPersSendClaimForPO.isError)
                await this.props.dispatch(this.props.dataItem.execute());
        } catch {
        }
    }
    editClaim = (claimKey) => {
        this.setState({showEditClaim: true, currentClaimKey: claimKey});
    }
    hideEditClaim = async (refresh = false) => {
        this.setState({showEditClaim: false, currentClaimKey: null}, () => {
            if (refresh)
                return this.props.dispatch(this.props.dataItem.execute());
        });
    }

    paramRender = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-2 text-right">
                    {h.lbl("DateBegin")}
                </div>
                <div className="col-4">
                    {h.ed("DateBegin")}
                </div>
                <div className="col-2 text-right">
                    {h.lbl("DateEnd")}
                </div>
                <div className="col-4">
                    {h.ed("DateEnd")}
                </div>
            </div>
            <div className="row mb-2">
                <div className="col-2 text-right">
                    {h.lbl("TypeClaimPersName")}
                </div>
                <div className="col-10">
                    {h.ed("TypeClaimPersName")}
                </div>
            </div>
            <div className="row">
                <div className="col-2 text-right">
                    {h.lbl("StatusClaimName")}
                </div>
                <div className="col-10">
                    {h.ed("StatusClaimName")}
                </div>
            </div>
        </>);
    };

    render() {
        if (!this.state.isDataReady)
            return null;
        return (<>
            <PlaceholderWrapper placeholderId={this.props.TypeClaimViewIntId === 2 ? "10" : "20"}
                                title={<><i className='fa fa-chain-broken'/> {this.props.settings.FormNameText ||
                                    (this.props.TypeClaimViewIntId === 1 ? i18next.t("Employees_Requests") : i18next.t("Requests_For_Trips"))}</>}
                                showSplitterLine={false} canCollapse={false}>

                {this.state.showCreateClaim &&
                    <CreateClaim rowKey={{TypeClaimViewIntId: this.props.TypeClaimViewIntId}}
                                 settings={this.props.settings}
                                 onClose={this.hideNewClaim} onCreated={this.claimCreated}/>}
                {this.state.showEditClaim &&
                    <EditClaim onClose={this.hideEditClaim} claimKey={this.state.currentClaimKey}
                               onPass={this.passClaim}/>}

                <button type="button" className="btn btn-regular btn-lg -goahead -wide"
                        title={this.props.settings["ButtonTextCreate"] || i18next.t("CreateStatement")}
                        onClick={this.createNewClaim}>
                    {this.props.settings["ButtonTextCreate"] || i18next.t("CreateStatement")}
                </button>
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="30" title={this.props.settings["ListClaimName"]}
                                showInstruction={false} showSplitterLine={false}>
                <ComplexParam dataItem={this.props.dataItem_Params} dispatch={this.props.dispatch}
                              renderParams={this.paramRender} className="mb-2"
                              autoApplyParams={true}
                              rootPath="/"
                              parentDataItem={this.props.dataItem}
                />
                <GridView dataItem={this.props.dataItem} dispatch={this.props.dispatch} readOnly={false}
                          renderCellEx={this.renderCellEx}/>
            </PlaceholderWrapper>
        </>)
    }

    getDocument = async (row) => {
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    renderCellEx = (cell) => {
        const {
            key,
            row,
            rowIndex,
            fieldInfo,
            fieldIndex,
            renderCellDefault
        } = cell;

        let self = this;

        if (fieldInfo.Name === "TextDel" && row["EnableDel"] === 1) {
            return <ActionLink onSelect={async () => {
                if (row["DoDel"]) {
                    if (row["DoDel"] === "delete") {
                        await this.deleteClaim(row)
                    } else if (row["DoDel"] === "rollback") {
                        await this.rollbackClaim(row)
                    }
                } else {
                    await this.deleteClaim(row)
                }
            }
            }>{row["TextDel"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextSend" && row["EnableSend"] === 1) {
            return <ActionLink onSelect={async () => {
                await this.passClaim(row)
            }}>{row["TextSend"]}</ActionLink>
        }

        if (fieldInfo.Name === "TextView") {
            return <ActionLink onSelect={() => {
                this.editClaim(row)
            }}>{row["TextView"]}</ActionLink>
        }

        if (fieldInfo.Name === "NoEDoc" && row["NoEDocIsLink"] === 1) {
            return <ActionLink onSelect={async () => {
                await this.getDocument(row)
            }}>{row["NoEDoc"]}</ActionLink>
        }
        return renderCellDefault(row, fieldInfo, fieldIndex);
    }
}
InternalClaim.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object,
    settings: PropTypes.object,
    ClaimPersSendClaimForPO: PropTypes.object,
    ClaimPersSaveScan: PropTypes.object,
    ClaimPers_RollbackClaimPO: PropTypes.object,
    TypeClaimViewIntId: PropTypes.number
};
InternalClaim.defaultProps = {};
function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state),
        dataItem_Params: ownProps.getItemStateParams(state),
        ClaimPersSendClaimForPO: state.claimState.ClaimPersSendClaimForPO,
        ClaimPersSaveScan: state.claimState.ClaimPersSaveScan,
        ClaimPers_RollbackClaimPO: state.claimState.ClaimPers_RollbackClaimPO
    }
}
const ConnectedInternalClaim = connect(mapStateToProps)(InternalClaim);